<div class="layout-main">
  <div class="container-fluid">

    <div class="symbols-title-row">
      <h3 class="mb-0"><b>Reporters</b></h3>
      <div class="search-wrapper">
        <i class="fa fa-search search-icon"></i>
        <input [(ngModel)]="searchQuery" class="form-control search-input" placeholder="Search reporters…"
               type="text">
      </div>
    </div>

    <ng-container *ngIf="!loading">

      <div *ngFor="let group of filteredGroups" class="symbols-market-table">
        <p-table [autoLayout]="true" [rowHover]="true" [value]="filteredReportersInGroup(group)">
          <ng-template pTemplate="caption">
            {{ group }}
            <span class="symbols-table-count">
              {{ filteredReportersInGroup(group).length }}
              reporter{{ filteredReportersInGroup(group).length !== 1 ? 's' : '' }}
            </span>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Account Name</th>
              <th>Shortname</th>
              <th>Customer ID</th>
              <th *ngFor="let dadConfigName of dadConfigNames">
                {{ dadConfigName.toUpperCase() }}
              </th>
            </tr>
          </ng-template>
          <ng-template let-reporter pTemplate="body">
            <tr>
              <td class="account-name">{{ reporter?.billingAccount?.name }}</td>
              <td class="shortname-cell">{{ reporter?.billingAccount?.shortname }}</td>
              <td class="id-cell">{{ reporter?.billingAccount?.customerId }}</td>
              <td *ngFor="let dadConfigName of dadConfigNames" class="reporter-cell">
                {{ getDadReporterFormDadConfig(reporter, dadConfigName) }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div *ngIf="loadError" class="empty-state">
        <i class="fa fa-exclamation-triangle mb-2"></i>
        <p>The reporters could not be loaded. Please try again later.</p>
      </div>

      <div *ngIf="!loadError && filteredGroups.length === 0" class="empty-state">
        <i class="fa fa-search mb-2"></i>
        <p>No reporters match your search.</p>
      </div>

    </ng-container>

  </div>
</div>
